import { CheckIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Link,
  Spacer,
  Spinner,
  Text,
} from "@chakra-ui/react";
import useChangeStatus from "../../../shared/useChangeStatus";

const UpNext = ({
  readingId,
  upNext,
  isLoading,
  premiumNotice,
  onPress,
  disableTracking,
  totalComics,
}) => {
  const { markAsRead } = useChangeStatus(readingId);

  if (isLoading || !upNext) {
    return (
      <Center p="30">
        <Spinner />
      </Center>
    );
  }

  return (
    <Box pt="3" px="6" pb="6">
      {/* Header title / premium notice */}
      <Flex>
        <Text fontSize="sm" color="gray.400" mb="2">
          UP NEXT
          {totalComics ? ` · ${upNext.order} OF ${totalComics}` : ""}
        </Text>
        <Spacer />
        {premiumNotice}
      </Flex>
      {/* Main content */}
      <Flex>
        <Box width="132px">
          <Image
            src={upNext?.thumbnail}
            alt={upNext?.title}
            maxW="120px"
            maxH="150px"
            cursor="pointer"
            onClick={() => onPress()}
          />
        </Box>
        <Box px="6" alignItems="flex-start" alignContent="flex-start" w="full">
          <Box flexGrow={2}>
            <Text
              fontWeight="bold"
              fontSize="lg"
              cursor="pointer"
              onClick={() => onPress()}
            >
              {upNext.title} {upNext.story && `[${upNext.story}]`}
            </Text>
            <Text fontSize="sm" noOfLines={3}>
              {upNext.description}
            </Text>
          </Box>
          <Flex mt="6" alignItems="center" w="full" gap="3">
            <Link href={upNext.url} isExternal>
              <Button
                size="sm"
                colorScheme="red"
                color="white"
                leftIcon={<ExternalLinkIcon />}
              >
                Read
              </Button>
            </Link>
            {!disableTracking && (
              <Button
                aria-label={`Mark ${upNext.title} as read`}
                size="sm"
                variant="outline"
                borderColor="white"
                color="white"
                borderRadius="full"
                w="36px"
                minW="36px"
                h="36px"
                p="0"
                onClick={() => markAsRead(upNext.id, upNext.story)}
              >
                <CheckIcon />
              </Button>
            )}
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default UpNext;
